import React from 'react';
import { formatDistanceToNow } from 'date-fns';

/**
 * Shared UI primitives for stock-sync components.
 * Extracted to avoid duplication across OrderSyncCard, PapSyncCard, and StockSyncOverview.
 */

/** Timestamp with freshness dot for last-synced display */
export function SyncTimestamp({
  timestamp,
  ordersSynced,
  className,
}: {
  timestamp: string;
  ordersSynced?: number | null;
  className?: string;
}) {
  const date = new Date(timestamp);
  const ageMs = Date.now() - date.getTime();
  const isRecent = ageMs < 10 * 60 * 1000;

  return (
    <span className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className ?? ''}`}>
      <span
        className={`inline-block h-1.5 w-1.5 rounded-full ${isRecent ? 'bg-green-500' : 'bg-amber-500'}`}
      />
      Last synced {formatDistanceToNow(date, { addSuffix: true })}
      {typeof ordersSynced === 'number' && ordersSynced > 0 ? ` (${ordersSynced} orders)` : ''}
    </span>
  );
}

/** Compact stat pill for sync progress/results */
export function SyncStat({ label, value, icon: Icon }: { label: string; value: string | number; icon?: React.ElementType }) {
  return (
    <div className="flex items-center gap-2 rounded-md bg-muted/60 px-2.5 py-1.5">
      {Icon && <Icon className="h-3.5 w-3.5 text-muted-foreground shrink-0" />}
      <span className="text-xs tabular-nums font-medium">{value}</span>
      <span className="text-xs text-muted-foreground">{label}</span>
    </div>
  );
}
